/** Full credit journey including “View my shortlist” (calculator with shortlisted vehicles). */
export const FULL_CREDIT_WIZARD_STEPS = [
  {
    step: 1,
    label: 'View my shortlist',
    routes: ['dashboard']
  },
  {
    step: 2,
    label: 'Business details <span="new-line">& credit application</span>',
    routes: ['applications', 'businessDetails']
  },
  {
    step: 3,
    label: 'ID check & application review',
    routes: ['applications', 'approvals', 'approvals-waiting', 'application-on-hold', 'id-scan']
  },
  {
    step: 4,
    label: 'Review & sign lease documentation',
    routes: ['applications', 'reviewAndSignContract']
  }
];

/** Calculator with no shortlists, or CRM `applicationType: scoreboard` with no shortlists: business details is step 1. */
export const COMPACT_CREDIT_WIZARD_STEPS = [
  {
    step: 1,
    label: 'Business details <span="new-line">& credit application</span>',
    routes: ['dashboard', 'applications', 'businessDetails'],
    fitLabel: true
  },
  {
    step: 2,
    label: 'ID check & application review',
    routes: ['applications', 'approvals', 'approvals-waiting', 'application-on-hold', 'id-scan']
  },
  {
    step: 3,
    label: 'Review & sign lease documentation',
    routes: ['applications', 'reviewAndSignContract'],
    fitLabel: true
  }
];

/** Map 4-step active indices to 3-step wizard when “View my shortlist” is omitted. */
export function mapActiveStepsWithoutShortlist(baseSteps) {
  const last = baseSteps[baseSteps.length - 1];
  if (baseSteps.length >= 5 || last >= 5) {
    return [1, 2, 3];
  }
  if (last <= 1) {
    return [1];
  }
  const newLast = Math.min(3, last - 1);
  return Array.from({ length: newLast }, (_, i) => i + 1);
}

export function baseProgressActiveStepsFromStatus(currentStatus, hasCreditTotal) {
  if (hasCreditTotal) {
    return [1, 2, 3, 4, 5];
  }
  switch (currentStatus) {
    case 'viewShortlist':
      return [1];
    case 'businessDetails':
      return [1, 2];
    case 'approvals':
      return [1, 2, 3];
    case 'reviewAndSignContract':
      return [1, 2, 3, 4];
    case 'finished':
      return [1, 2, 3, 4, 5];
    default:
      return [1];
  }
}
